import * as IoC from 'typescript-ioc';

import { IApiClient } from '../../infrastructure/api-client';
import * as USERS_GROUPS_API from '../../constants/api/users-groups';
import {
    IUserGroupCreateDTO,
    IUserGroupDTO,
    IUserGroupsDAO,
    IUserGroupsListDTOInternal
} from '../user-groups.dao';

interface IGetUsersParams {
    query?: string;
    page?: number;
    size?: number;
}

class UserGroupsDAO extends IUserGroupsDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getUserGroups(params: IGetUsersParams & { accountId: number}): Promise<IUserGroupsListDTOInternal> {
        const response = await this.apiClient.get<IUserGroupsListDTOInternal>(USERS_GROUPS_API.USER_GROUPS_LIST_URL, params || {});
        return response.parsedResponse;
    }

    public async getUserGroup(params: { userGroupId: number; accountId: number}): Promise<IUserGroupDTO> {
        const response = await this.apiClient.get<IUserGroupDTO>(USERS_GROUPS_API.GET_USER_GROUP_URL, params);
        return response.parsedResponse;
    }

    public async createGroup(params: IUserGroupCreateDTO & { accountId: number}): Promise<IUserGroupDTO> {
        const response = await this.apiClient.post<IUserGroupDTO>(
            USERS_GROUPS_API.CREATE_USER_GROUP_URL, params
        );
        return response.parsedResponse;
    }

    public async editGroup(params: IUserGroupDTO & { accountId: number}): Promise<IUserGroupDTO> {
        const response = await this.apiClient.put<IUserGroupDTO>(
            USERS_GROUPS_API.EDIT_USER_GROUP_URL, params, {
                requestInit: {body: JSON.stringify(params)}
            }
        );
        return response.parsedResponse;
    }

    public async deleteGroup(params: {userGroupId: number} & { accountId: number}): Promise<void> {
        await this.apiClient.delete<void>(
            USERS_GROUPS_API.DELETE_USER_GROUP_URL, params
        );
    }

}


export { UserGroupsDAO };
